/* 
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved. */

/*global showAjaxError:true*/
import {
  Polymer,
  html
} from '@polymer/polymer/polymer-legacy.js';

const template = html `  
        <style include="app-styles mdl-grid-css">
            .margin-top-25 {
              margin-top: 25px;
            }

            .padding-left-2-percent {
                margin-left: 16px;
                margin-right:8px;
            }
			
			:dir(rtl) .padding-left-2-percent {
                margin-right: 2%;
            }

            .padding-top-20px {
                padding-top: 20px;
            }
            
            app-dialog {
              --dialog-background-color: {
                  background-color: var(--brand-color);
              }
          }

          app-dialog {
              --dialog-text-color: {
                  color: var(--background-primary);
              }
          }
          .multipleDataDisplayHeight{
            max-height: 40vh;
            overflow: auto;
          }
          .outlineAddOffset:focus{
            outline: 2px solid #0075da;
            outline-offset: 4px;
          }  
          .accountinfodisplay{
            width:0px;
            height:0px;
          }
        </style>

        <!--<oe-ajax id="getOperativeAccountDetails" url="/api/transactiondebitaccounts/transactiondebitaccounts?filter[where][transactionType]=this.transactionType" on-error="_showError" on-response="loadOperativeAccounts"></oe-ajax>-->
        

        <oe-ajax id="getOperativeAccountDetails" content-type="application/json" handle-as="json" method="get" on-response="loadOperativeAccounts"
                on-error="_errorReasons"></oe-ajax>

        <oe-ajax id="fetchBalance" content-type="application/json" handle-as="json" method="get" on-response="getFromAccountsRequests"
                on-error="_errorReasons"></oe-ajax>
              <div hidden={{!loaderActive}}>
                <div class="spinner-div vertical center-justified layout">
                  <paper-spinner id="app_list_box_spinner" active></paper-spinner>
                </div>
              </div>
        <div class="shadow" hidden$="{{loaderActive}}">
            <template is="dom-if" if="{{onlyOneAccountForDropDown}}">
                <div class="primary-dark-text-m margin-top-2em">
                  <oe-i18n-msg msgid="l_fromAccount" hidden$="{{hideFromAccountLabel}}"></oe-i18n-msg>
                  <oe-i18n-msg class="mdl-cell margin-l-zero mdl-cell--6-col">{{operativeAccountsList.0.accountNickName}} {{operativeAccountsList.0.accountMasked}}
                </oe-i18n-msg>
           </template> 

            <template is="dom-if" if="{{!onlyOneAccountForDropDown}}">
                  <div class="margin-top-18">
                    <oe-i18n-msg class="primary-dark-text-s" msgid="l_fromAccount" hidden$="{{hideFromAccountLabel}}"></oe-i18n-msg>
                    <div class="mdl-cell margin-l-zero mdl-cell--12-col primary-dark-text-m">
                      <span class="outlineOffset outlineAddOffset" tabindex="0">
                        <span class="accountinfodisplay" aria-labelledby="hiddenDescMessage">
                          <div id="hiddenDescMessage" class="display-none">
                              <oe-i18n-msg msgid="l_fromAccount" hidden$="{{hideFromAccountLabel}}"></oe-i18n-msg>
                          </div>  
                        </span>
                        {{selectedFromAccount.accountNickName}}&nbsp;{{maskedAccountId(selectedFromAccount.accountId)}}</span>
                        <paper-button on-tap="_showAccountSelectionOverlay" class="text-brand-color text-transform-uppercase padding-zero outlineAddOffset" on-keydown="_showAccountSelectionwithDDA">
                        <template is="dom-if" if="{{recordsMatched}}">
                          <oe-i18n-msg msgid="b_changeTxt" ></oe-i18n-msg>
                        </template>
                        <template is="dom-if" if="{{!recordsMatched}}">
                          <oe-i18n-msg msgid="b_Select" ></oe-i18n-msg>
                        </template>
                      </paper-button>
                    </div>
                </div>
            </template>

        </div>
        
        
        <app-dialog name="h_ChooseAccount" id="accountSelectionOverlayElem" elementid="accountSelectionOverlay">
        <template is="dom-if" if="{{transactionAccountList}}">
            <div class="margin-top-2em multipleDataDisplayHeight" role="table">
                <template is="dom-repeat" items="{{transactionAccountList}}">
                    <div role="row" id="chooseAccId_{{index}}" class="outlineOffset mdl-cell margin-top-zero mdl-cell--12-col" phone$="{{phone}}" on-keydown="_selectAccountwithDDA" tabindex="0">
                        <div class="outlineOffset horizontal center layout cursor-pointer" on-tap="_selectAccount" tabindex="0">
                           <!-- <app-fab small name="{{item.accountNickname}}" image="{{item.accountImageURL}}" id="icon{{index}}"></app-fab>-->
                            <div role="cell" class="mdl-cell margin-t-zero margin-b-zero flex-1 text-overflow-ellipsis">
                                <div id="nickname{{item.accountId}}" class="primary-dark-text-m text-overflow-ellipsis font-medium text-align-left">{{item.accountNickName}}&nbsp;</div>
                                <div class="horizontal layout">
                                    <span id="maskedAccountNumber{{item.accountId}}" class="secondary-dark-text-s">{{item.branchCode}}&nbsp;|&nbsp;{{maskedAccountId(item.accountId)}}</span>
                                </div>
                            </div>
                            <div role="cell" class="horizontal center end-justified layout">
                                <div class="vertical center-justified end layout">
                                    <div role="info" aria-labelledby="availableBalanceLabel{{item.accountId}}" id="accountAvailableBalance{{item.accountId}}" class="primary-dark-text-m font-medium cursor-pointer font-weight-bold">
                                        {{symbolizeCurrency(item.balances.1.amountDetails.amount, item.balances.1.amountDetails.currency)}}
                                    </div>
                                    <div id="availableBalanceLabel{{item.accountId}}" class$="secondary-dark-text-s">
                                        <oe-i18n-msg class="secondary-dark-text-s" msgid="l_AvailableBalance"></oe-i18n-msg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="mdl-cell margin-t-zero mdl-cell--12-col" hidden$={{phone}}> -->
                    <div class="border-b-1px bottom-border padding-left-2-percent" hidden$="{{_checkLastIndex(index,operativeAccountsList)}}"></div>
                    <!-- </div> -->
                </template>
            </div>
            </template>
            <template is="dom-if" if="{{!norecords}}">
            <supporting-msg title-msg="l_noRecordsFound" icon-name="no_txn" ></supporting-msg>
          </template>
        </app-dialog>
        <div  id="availlableBalance" on-blur="removeTab" class="mdl-cell margin-zero mdl-cell--12-col-phone mdl-cell--8-col-tablet mdl-cell--12-col-desktop secondary-dark-text-s text-align-left full-width" hidden$="{{hideAvailableBalance}}">
            <oe-i18n-msg msgid="l_AvailableBalance"></oe-i18n-msg> <span class="font-weight-bold">{{symbolizeCurrency(selectedFromAccount.balances.1.amountDetails.amount, selectedFromAccount.balances.1.amountDetails.currency)}}</span>
        </div>

`;
Polymer({
  is: "account-selection",
  behaviors: [sbBehaviours.currencyFormatorBehaviour, corpBehaviours.appCommonBehaviour],
  _template: template,
  properties: {
    userId: {
      type: String,
      notify: true,
      value: function () {
        return clientStorage.get(storageType.session, 'userId');
      }
    },
    operativeAccountsList: {
      type: Array,
      notify: true,
      value: [],
      observer: '_operativeAccounstListChanged'
    },
    totalOperativeAccountsList: {
      type: Array,
      notify: true,
      value: [],
    },
    primaryAccount: {
			type: Object,
			notify: true
		},
    filterSelectedAccount: {
      type: Object,
      value: {
        'accountId': "defaultValue"
      },
      // used only for conditions when the value will not be passed from the parent component
      notify: true,
      observer: "_filterSelectedAccountChanged"
    },
    selectedFromAccount: {
      type: Object,
      notify: true,
      observer: "_selectedFromAccountChanged"
    },
    selectedFromAccountIdComboSelection: {
      type: String,
      value: "",
      notify: true,
      observer: '_seletedFromAccountIdComboChanged'
    },
    onlyOneAccountForDropDown: {
      type: Boolean,
      notify: true,
      value: false
    },
    availableBalanceSymbolized: {
      type: String,
      notify: true,
      value: null
    },
    accountSelectionLoaded: {
      type: Boolean,
      notify: true
    },
    preSelectedFromAccountId: {
      type: String,
      notify: true,
      observer: "_preSelectedFromAccountIdChanged"
    },
    repeatTransactionClickedFlag: {
      type: Boolean,
      value: false,
      notify: true
    },
    onlyOneOperativeAccountFlag: {
      type: Boolean,
      value: false,
      notify: true
    },
    transactionType: {
      type: String,
      notify: true,
      observer: "_transactionTypeChanged"
    },
    hideAvailableBalance: {
      type: Boolean,
      notify: true,
      value: false
    },
    hideFromAccountLabel: {
      type: Boolean,
      notify: true,
      value: false
    },
    loaderActive: {
      type: Boolean,
      notify: true,
      value: false
    },
    _isRequest: {
      type: Boolean,
      value: true
    },
    norecords: {
      type: Boolean,
      value: true
    }
  },
  attached: function () {
    // this.$.getOperativeAccountDetails.url = "api/transactionDebitaccounts/transactionDebitAccounts" + "?filter[where][transactionType]=PMT";
    // this.$.getOperativeAccountDetails.generateRequest();
    this.$.fetchBalance.url = "/api/CBUsers/" + this.userId + "/accounts";
  },
  _transactionTypeChanged: function () {
    this.$.getOperativeAccountDetails.url = "api/TransactionDebitaccounts/transactionDebitAccounts" + "?filter[where][transactionType]=" + this.transactionType;
    this.getOperativeAccount();
  },
  getBalance: function (accountId) {
    /* var ajaxCall = document.createElement('oe-ajax');
     ajaxCall.contentType = "application/json";
     ajaxCall.handleAs = "json";
     ajaxCall.url = "/api/CBUsers/" + this.userId + "/accounts" + "?filter[where][accountId]=" + accountId;
     ajaxCall.method = "get";
     var self = this;
     ajaxCall.addEventListener('response', function (event) {
       var response = event.detail.response[0];
       // console.log(response);
       //console.log(self.symbolizeCurrency(response.balances[1].amountDetails.amount, response.balances[1].amountDetails.currency));
       return response.balances[1].amountDetails.amount + " " + response.balances[1].amountDetails.currency;
     });
     ajaxCall.generateRequest();*/
  },
  getFromAccountsRequests: function (event) {
    if (event) this._isRequest = true;
    // defect 399262 start  fixed -- primary account get and populated in available balance --
    // this assign old value & id=constant
    var primaryAccountObj = clientStorage.get(storageType.session, 'primaryAccount');
    // defect 399262 end
    if (event.detail && event.detail.__data && event.detail.__data.response) {
      this.balanceAccount = event.detail.__data.response;
    }
    var self = this;
    var finalArr = self.balanceAccount.filter(({
        accountId
      }) =>
      self.totalOperativeAccountsList.some(exclude => exclude.accountId === accountId)
    );

    // defect -- and 394400-- fixed without affecting 399262 start ---
    // updating the from available balance  for primary account too
    for (var i = 0; i < finalArr.length; i++) {
    if (primaryAccountObj !== null) {
      if (primaryAccountObj.accountId === finalArr[i].accountId) {
        // assigning updated value id=constant
        primaryAccountObj = finalArr[i];
      }
    }
      } // defect -- and 394400-- fixed end ---
    this.transactionAccountList = finalArr;
    
     //fixed defect 362184 and 362676 --start
    // this should be client storage
    // var primaryAccountObj = this.transactionAccountList[0];
    if (_.isEmpty(this.selectedFromAccount)) {
      if (primaryAccountObj) {
        self.selectedFromAccount = primaryAccountObj;
      }
      else {
        this.selectedFromAccount = this.transactionAccountList[0];
      }
    }
    //fixed defect 362184 and 362676 --end
    
    var temp = this.preSelectedFromAccountId;
    this.set("preSelectedFromAccountId", undefined);
    this.set("preSelectedFromAccountId", temp);
    this.loaderActive = false;
  },
  getOperativeAccount: function () {
    // this.loadConstants();
    this.loaderActive = true;
    if (this.$.getOperativeAccountDetails) {
      this.$.getOperativeAccountDetails.generateRequest();
    }
  },
  /*loadConstants: function () {
    this.activeAccountType = "A";
    this.totalBalanceType = "totalBalance";
    this.availableBalance = "availableBalance";
  },*/
  loadOperativeAccounts: function (event) {
    var self = this;

    if (event.detail && event.detail.__data && event.detail.__data.response) {
      var filterOperativeAccounts = event.detail.__data.response; //Filtering operative accounts which are ACTIVE and are not filtered out based on the proerty given ( the selected account should be removed from the drop down entries)
      //var filterOperativeAccounts =
      /* filterOperativeAccounts = Array.prototype.filter.call(filterOperativeAccounts, function (singleOperativeAccount) {
         return singleOperativeAccount.accountStatus.cmCode === self.activeAccountType && self.filterSelectedAccount.accountId != singleOperativeAccount.accountId;
       });*/
      self.set('operativeAccountsList', filterOperativeAccounts); // self.loaderActive = false;
      self.totalOperativeAccountsList = _.cloneDeep(filterOperativeAccounts);
      var primaryAccountObj = clientStorage.get(storageType.session, 'primaryAccount');
      this.recordsMatched = false;
      if (primaryAccountObj) {
        if (filterOperativeAccounts.length == 1) {
          // length 0 is ensured when the only operative account present has been selected as the to account for transfer
          self.onlyOneAccountForDropDown = true; //NO SELECT/CHANGE
        } else if (filterOperativeAccounts.length > 1) {
          let self = this;
          filterOperativeAccounts.forEach(function (account) {
            if (account.accountId == primaryAccountObj.accountId) {
              self.recordsMatched = true;
            }
          });
        }
        else if (filterOperativeAccounts.length < 1) {
          this.fire('oe-show-error', getLabel("m_requestError"));
          this.loaderActive = false;
        }
      }
      if (!filterOperativeAccounts.length < 1) {
        if (self._isRequest) {
          self.$.fetchBalance.generateRequest();
          self._isRequest = false;
          self.accountSelectionLoaded = true;
        }
      }
    }
  },
  _showError: function (e) {
    showAjaxError(e);
    this.loaderActive = false;
  },
  _seletedFromAccountIdComboChanged: function (newValue) {
    var self = this;
    var fetchSelectedAccount = this.operativeAccountsList;
    fetchSelectedAccount = Array.prototype.filter.call(fetchSelectedAccount, function (singleOperativeAccount) {
      return newValue == singleOperativeAccount.accountId;
    });
    // if (fetchSelectedAccount[0]) self.set('selectedFromAccount', fetchSelectedAccount[0]);
  },
  _selectedFromAccountChanged: function (newValue) {
    this.primaryAccount = newValue;
    var selectedprimaryaccount = clientStorage.get(storageType.session, 'primaryAccount');
    // if (newValue && newValue.balances) {
    //    var availableBalance = this._fetchAvailableBalance(newValue.balances);

    //    this.availableBalanceSymbolized = this.symbolizeCurrency(availableBalance.amountDetails.amount, availableBalance.amountDetails.currency);

  },
  /* _fetchAvailableBalance: function (balancesArray) {
     var totalBalance = Array.prototype.filter.call(balancesArray, function (singleBalanceObject) {
       return singleBalanceObject.type === "availableBalance";
     }); // returning the first instance since there will be only one element to this array that contains the available balance for the account

     return totalBalance[0];
   },*/
  _operativeAccounstListChanged: function (newValue) {
    for (var i = 0; i < newValue.length; ++i) {
      //branch id added for feature 301793
      var displayBoxAccountFormatted = this.maskedAccountId(newValue[i].accountId);
      var accountMasked = newValue[i].branchCode + ' ' + "|" + ' ' + newValue[i].accountId;
      this.operativeAccountsList[i]['displayBoxAccountFormatted'] = displayBoxAccountFormatted;
      this.operativeAccountsList[i]['accountMasked'] = accountMasked;
    }
    if (newValue.length && newValue.length == 1) this.onlyOneAccountForDropDown = true;
    else // condition added for a bug fix when navigating back the value of flag was getting set to true when it should not have been set
      this.onlyOneAccountForDropDown = false;
  },
  maskedAccountId: function (accountId) {
    return maskAccount.accountFormat(accountId);
  },
  symbolizeCurrency: function (amount, curr) {
    //return currency.symbolize(amount + " " + curr);
    if (!_.isUndefined(curr) && !_.isUndefined(amount)) {
    return this._symbolizeCurrency(curr + " " + amount);
    }
  },
  _filterSelectedAccountChanged: function (newValue) {
    var self = this;
    var filterAccountPassed = newValue;
    var currentOperativeAccountsList = this.operativeAccountsList;

    if (currentOperativeAccountsList && filterAccountPassed) {
      currentOperativeAccountsList = Array.prototype.filter.call(currentOperativeAccountsList, function (singleOperativeAccount) {
        return filterAccountPassed.accountId != singleOperativeAccount.accountId;
      });
      self.set('operativeAccountsList', currentOperativeAccountsList);
    }
  },
  _showAccountSelectionOverlay: function () {
    // if (this.operativeAccountsList && this.operativeAccountsList.length > 0) {
      this.$$('#accountSelectionOverlayElem').$$("#accountSelectionOverlay").open();
  },
  _showAccountSelectionwithDDA: function (event) {
    if (event.keyCode === 13) {
      this._showAccountSelectionOverlay();
    }
  },
  _selectAccount: function (event) {
    if (event && event.model && event.model && event.model.item) {
      this.selectedFromAccount = event.model.item;
      this.$$('#accountSelectionOverlayElem').$$("#accountSelectionOverlay").close();
    }
  },
  _selectAccountwithDDA: function (e) {
    if (e.keyCode === 13 || e.keyCode === 32) {
      this._selectAccount(e);
    }

    var self = this;

    if (e.keyCode === 40) {
      if (self.operativeAccountsList.length - 1 === e.model.index) {
        e.target.parentNode.children[0].focus();
      } else {
        if (e.target.nextElementSibling) {
          e.target.nextElementSibling.nextElementSibling.focus();
        }
      }

      if (self.operativeAccountsList[e.model.index + 1] == undefined) {
        e.target.parentNode.children[1].focus();
      }
    } else if (e.keyCode === 38) {
      if (e.model.index == 0) {
        e.target.parentElement.children[e.model.children.length + 1].focus();
      } else {
        if (e.target.previousElementSibling) {
          e.target.previousElementSibling.previousElementSibling.focus();
        }
      }
    }
  },
  _checkLastIndex: function (index, list) {
    if (index === list.length - 1) return true;
    return false;
  },
  _preSelectedFromAccountIdChanged: function (newValue) {
    if (this.preSelectedFromAccountId != undefined){
    if (newValue && this.totalOperativeAccountsList) {
      // Fetch the account object from the account ID passed from parent
      var accountIdTrimmed = newValue.trim();
      var tempOperativeAccountsList = this.totalOperativeAccountsList;
      if(!_.isEmpty(this.transactionAccountList)){
        tempOperativeAccountsList = this.transactionAccountList;
      }
      tempOperativeAccountsList = Array.prototype.filter.call(tempOperativeAccountsList, function (singleOperativeAccount) {
        return accountIdTrimmed == singleOperativeAccount.accountId;
      }); 
      if (tempOperativeAccountsList.length > 0) // Check added although its length will always be 1 because the from account id will be mathed with a single account in the opreative accounts list fetched 
        this.selectedFromAccount = tempOperativeAccountsList[0]; //self.set('selectedFromAccount', tempOperativeAccountsList[0]);
      // return accountObjectFromId;
    }
  }
  },
  _errorReasons: function (e) {
    this.loaderActive = false;
    this.recordsMatched = false;
    this.norecords = false;
    showAjaxError(e);
  }
});